/**
 * @generated SignedSource<<0725dcb91a3f4d7721d9b20f2b48ad7a>>
 * @relayHash c674cc7869ab43d6a33c0e361b3fbe6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 72e36f96d29cb08589218e38ab81f6ec1f3bed125870500e850fd53945ccd070

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RoadmapsContentViewQuery } from './RoadmapsContentViewQuery.graphql';

const node: PreloadableConcreteRequest<RoadmapsContentViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "72e36f96d29cb08589218e38ab81f6ec1f3bed125870500e850fd53945ccd070",
    "metadata": {},
    "name": "RoadmapsContentViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
